<template>
  <div v-loading="loading">
    <div class="title">项目任务</div>
    <div class="search-box">
      <div>
        <CascaderPosition
          size="medium"
          :job-id.sync="job_id"
        ></CascaderPosition>
        <el-date-picker
          class="w-200 mr-12"
          v-model="end_date"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="截止时间"
          size="medium"
        >
        </el-date-picker>

        <el-button type="primary" size="medium" plain @click="search"
          >查询</el-button
        >
        <el-button size="medium" @click="clearSearch">重置</el-button>
      </div>
      <div>
        <el-link
          style="height: 100%"
          size="medium"
          icon="el-icon-question"
          @click="openWay"
          :underline="false"
          >项目生产指南</el-link
        >
      </div>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="50" label="编号" prop="id"></el-table-column>
      <el-table-column width="340" label="选题方向" prop="job.name">
        <template slot-scope="scope">
          <div style="font-size: 12px;">
            {{ scope.row.job.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="135" label="题目需求说明">
        <template slot-scope="scope">
          <div
            class="hidden-redundant"
            @click="openDialog(scope.row.description)"
          >
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>项目单价</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.unit_price_min + ' ~ ' + scope.row.unit_price_max"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="150" label="任务截止时间">
        <template slot-scope="scope">
          <div v-if="scope.row.end_date">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.end_date }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="authPermissions.includes('project.api.fuwu_admin.projects.store')"
        width="80"
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="assignTopic(scope.row.id)"
            >创建项目</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>

    <el-dialog
      class="skill-task-dialog"
      :visible.sync="dialogVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="dialogDescription"></markdown-it>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import projectService from "@/global/service/project";
import CascaderPosition from "./widgets/CascaderPosition.vue";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    MarkdownIt,
    CascaderPosition,
    ShowHideContent
  },
  data() {
    return {
      loading: true,
      isShow: false,
      selectLoading: false,
      end_date: null,
      job_id: null,
      list: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogDescription: ""
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize,
        job_id: this.job_id,
        end_date: this.end_date
      };
      this.loading = true;
      projectService
        .task(params)
        .then(res => {
          this.list = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openWay() {
      window.open("https://jiker.feishu.cn/docs/doccnFc3wTqFxVmf3ikuT4kxlEg");
    },
    assignTopic(id) {
      this.$router.push({
        name: "ProjectCreate",
        params: { id }
      });
    },
    goPage(val) {
      this.$router.push({
        name: "ProjectTaskSelf",
        query: { page: val }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    search() {
      this.getData();
    },
    clearSearch() {
      this.job_ids = [];
      this.end_date = null;
      this.getData();
    },
    openDialog(description) {
      this.dialogVisible = true;
      this.dialogDescription = description;
    }
  }
};
</script>

<style lang="less">
.skill-task-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
</style>
